// Where a visitor came from, kept in the cookie bb_src for 90 days (2026-10-19). The API reads it when the
// visitor signs up and stores it in users.referer, so the admin page Revenue can count sign-ups per source
// (do the Facebook group posts pay off?).
//
// Kept from the first visit that says anything: utm_* tags, an ad click id, an outside referring site.
// A later visit replaces it only when the stored one is bare ("direct") and the new one is not.
// Format: a short query string – s/m/c/ct = utm source/medium/campaign/content, click = fb|g|ms|tt,
// ref = referring host, land = landing path, t = date. No personal data. fbclid is added by Facebook to every
// outgoing link (group posts too, not only ads), so click=fb means "came from Facebook".

const COOKIE = 'bb_src'
const DAYS = 90

function readCookie (name) {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
  return m ? decodeURIComponent(m[1]) : null
}

export function rememberSource () {
  try {
    const url = new URL(window.location.href)
    const q = url.searchParams
    const p = new URLSearchParams()
    const cut = (v, n) => (v || '').slice(0, n)
    if (q.get('utm_source')) p.set('s', cut(q.get('utm_source'), 40))
    if (q.get('utm_medium')) p.set('m', cut(q.get('utm_medium'), 40))
    if (q.get('utm_campaign')) p.set('c', cut(q.get('utm_campaign'), 60))
    if (q.get('utm_content')) p.set('ct', cut(q.get('utm_content'), 60))
    if (q.get('fbclid')) p.set('click', 'fb')
    else if (q.get('gclid') || q.get('gbraid') || q.get('wbraid')) p.set('click', 'g')
    else if (q.get('msclkid')) p.set('click', 'ms')
    else if (q.get('ttclid')) p.set('click', 'tt')
    let refHost = ''
    try { refHost = document.referrer ? new URL(document.referrer).hostname : '' } catch (e) {}
    if (refHost && !/(^|\.)bytbostad\.se$/.test(refHost)) p.set('ref', cut(refHost.replace(/^www\./, ''), 60))
    const telling = p.toString() !== ''
    p.set('land', cut(url.pathname, 80))
    p.set('t', new Date().toISOString().slice(0, 10))

    const stored = readCookie(COOKIE)
    const storedBare = stored !== null && !/(^|&)(s|click|ref)=/.test(stored)
    if (stored !== null && !(storedBare && telling)) return

    const domain = /(^|\.)bytbostad\.se$/.test(window.location.hostname) ? '; domain=.bytbostad.se' : ''
    document.cookie = COOKIE + '=' + encodeURIComponent(p.toString()) + '; max-age=' + (DAYS * 86400) +
      '; path=/' + domain + '; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '')
  } catch (e) {
    // never let attribution break the page
  }
}
